import  { 	CARGAR_GESTIONES_CLIENTE, CARGAR_GESTIONESPLANIF_CLIENTE } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargar_GestionesPorCliente = (idCliente) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/clientes/${idCliente}/gestiones`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {			
			dispatch({
				type: CARGAR_GESTIONES_CLIENTE,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar gestiones de cliente', mensaje: msgError}
			});
		});
	}
}

export const cargar_GestionesPlanificadas = (fechaDesde, fechaHasta) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/plangestionescliente?fechaPlanDesde=${fechaDesde}&fechaPlanHasta=${fechaHasta}`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			dispatch({
				type: CARGAR_GESTIONESPLANIF_CLIENTE,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar gestiones planificadas de cliente', mensaje: msgError}
			});
		});
	}
}